export default {
  "settlementPending": "Payment confirmation is pending. Refresh your account or check again shortly before retrying.",
  "checkoutOpenFailed": "Secure checkout could not be opened. Please try again.",
  "checkoutClosed": "Checkout was closed. Payment confirmation may still be pending. Check the result before trying again.",

  "returnToApp": "Return to app",
  "dashboard": "Dashboard",
  "account": "Account",
  "currentBalance": "Current Balance",
  "balanceUnavailable": "Balance unavailable",
  "balanceLoading": "Balance loading",
  "lastUpdated": "Last updated",
  "monthlyBillHelp": "These charges will be included in your monthly bill.",
  "billingPeriod": "Billing period",
  "currentMonth": "Current month",
  "billableItems": "Billable items",
  "payBalance": "Pay current balance",
  "settleHelp": "Settle your current balance securely online.",
  "autoRefreshHelp": "We’ll refresh your balance automatically after checkout confirms.",
  "retry": "Retry",
  "noCharges": "You have no current charges.",
  "clearHelp": "Your account is clear for the current billing period.",
  "statementItems": "Current statement items",
  "includedThisMonth": "Included in this month’s bill",
  "preparingCheckout": "Preparing secure checkout…",
  "paymentsDisabled": "Online payments are not enabled for this club yet.",
  "paymentsSetup": "Online payments are being set up by the club.",
  "paymentReceived": "Payment received. Your account balance is now up to date.",
  "statementUpdating": "Payment received. Your statement is being updated.",
  "paymentCancelled": "Payment was cancelled. No payment was taken.",
  "allowPopups": "Please allow pop-ups to open secure checkout in a new tab.",
  "checkoutOpened": "Secure checkout opened in a new tab.",
  "checkoutFailed": "We could not prepare secure checkout. Please try again shortly.",
  "items": "{count} item",
  "itemsMany": "{count} items",
  "refreshing": " · Refreshing",
  "loadFailed": "Your balance could not be loaded. Please try again.",
  "unknownStatus": "Status unavailable",
  "noBalanceDue": "No balance due.",
  "balanceUnconfirmed": "Your current balance could not be confirmed. Please refresh your account.",
  "currencyUnavailable": "Online payment currency is unavailable. Please contact the club."
}
